import { TubeStatus_t } from 'foreman-slink';

/** The view model for the tubes cleaned graph. */
export interface TubesCleanedGraphDataElement {
  /** The time in ms since the job started that the event occurred. */
  msElapsed: number;
  /** The instant (expressed in epoch ms) that the event occurred. */
  timestamp: number;
  /** The number of tubes that were successfully cleaned at this point in time. */
  cleaned: number;
  /** The number of tubes that were unsuccessfully cleaned at this point in time. */
  uncleaned: number;
  /** The total number of tubes in the job. */
  total: number;
}

/** The view model for the pressure graphs. */
export interface JobPressureGraphDataElement {
  timestamp: number;
  pressure: number;
}

export interface JobLogV2DataPressureSort {
  msElapsed: number;
  pressure: number;
  sortFirst?: boolean;
}

export type TubesCleanedGraphDataSegment = TubesCleanedGraphDataElement[];
export type JobPressureGraphDataSegment = JobPressureGraphDataElement[];

/** The view model for the tube sheet graph. */
export interface TubeSheetGraphDataElement {
  x: number;
  y: number;
  cleanTime: number;
  status: TubeStatus_t;
  autoStroke: boolean;
  radius: number;
  depth: number;
  lanceSpeed: number;
  description: {
    depth?: string;
    autoStroke?: string[];
    lanceSpeed?: string;
    duration?: string;
  };
}

export type TubeSheetGraphDataSegment = TubeSheetGraphDataElement[];

export interface TubeSheetGraphBreakpoint {
  avg: number;
  warning: number;
  danger: number;
}

export interface TubeSheetGraphData {
  segments: TubeSheetGraphDataSegment[];
  breakpoints: {
    duration: TubeSheetGraphBreakpoint;
    lanceSpeed: TubeSheetGraphBreakpoint;
    depth: TubeSheetGraphBreakpoint;
  };
}

/** Describes a mask over a graph that communicates a safe range of values along the y-axis. */
interface JobGraphMaskSafeY {
  type: 'safe-y';
  /** The minimum value included in the safe area. */
  yMin: number;
  /** The maximum value included in the safe area. */
  yMax: number;
}

/** Describes all possible types of masks over a job graph. */
export type JobGraphMask = JobGraphMaskSafeY;

export enum TubeSheetChartType {
  MAIN = 'MAIN',
  HEAT = 'HEAT',
  DEPTH = 'DEPTH',
  AUTOSTROKES = 'AUTOSTROKES',
  LANCESPEED = 'LANCESPEED',
}
